import { DateTime } from 'luxon';

export interface CrmSettingRow {
  _id?: string;
  status?: boolean;
  name?: string;
  properties?: {
    provider_name?: string;
  };
}

export interface CrmProviderOption {
  value: string;
  label: string;
  disabled: boolean;
}

export const FALLBACK_CRM_PROVIDER_OPTIONS: CrmProviderOption[] = [
  { value: 'dealersocket', label: 'Dealersocket', disabled: false },
  { value: 'drivecentric', label: 'Drivecentric', disabled: false },
  { value: 'elead', label: 'Elead', disabled: false },
  { value: 'promax', label: 'Promax', disabled: false },
  { value: 'tekion', label: 'Tekion', disabled: false },
  { value: 'tmscan', label: 'Tmscan', disabled: false },
  { value: 'vinsolutions', label: 'vinsolutions', disabled: false },
];

export function getDefaultUploadDateRange(): [DateTime, DateTime] {
  const end = DateTime.now().startOf('day');
  const start = end.minus({ months: 1 });
  return [start, end];
}

export function getLatestActiveCrmProvider(settings: CrmSettingRow[]): string {
  const activeSettings = settings.filter(setting => setting.status === true);
  if (!activeSettings.length) {
    return '';
  }

  const sorted = [...activeSettings].sort((a, b) =>
    String(b._id || '').localeCompare(String(a._id || '')),
  );

  return sorted[0]?.properties?.provider_name || '';
}

export function getCrmProviderOptions(
  settings: CrmSettingRow[],
): CrmProviderOption[] {
  const providers = settings
    .map(setting => setting.properties?.provider_name || '')
    .filter(Boolean);

  const uniqueProviders = Array.from(new Set(providers));

  if (!uniqueProviders.length) {
    return [];
  }

  return uniqueProviders.map(provider => ({
    value: provider,
    label: provider,
    disabled: !settings.some(
      setting =>
        setting.properties?.provider_name === provider && setting.status === true,
    ),
  }));
}
